import React from 'react';
import { Stack } from '@cp/ds/src/components/stack';
import { Typography } from '@cp/ds/src/components/typography';
import { Skeleton } from '@cp/ds/src/components/skeleton';
import { Button } from '@cp/ds/src/components/button';
import { ChevronRightIcon } from '@cp/ds/src/icons';
import { Box } from '@cp/ds/src/components/box';
import { useIsMobile } from '@cp/ds/src/hooks/useIsMobile';
import { Container } from '@cp/ui';
import { mergeSx } from '@cp/ds/src/utils/sx/merge';
import { coreCareerApi } from '@cp/entities/career';
import { CareerId } from '@common/const/catalog/career';

export interface HeaderProps {
  onGoBack?: () => void;
  careerId: CareerId;
  endAdornment?: React.ReactNode;
}

export const Header: React.FC<HeaderProps> = ({ onGoBack, careerId, endAdornment }) => {
  const isMobile = useIsMobile();
  const { data: careerDictionary, isLoading: isLoadingCareerDict } = coreCareerApi.endpoints.getCareers.useQuery();

  const title = (
    <Typography variant="h2">
      {isLoadingCareerDict ? (
        <Skeleton width={150} />
      ) : (
        `Найти ${careerDictionary && careerId ? careerDictionary[careerId].translation.nameSingleAccusative : 'специалиста'}`
      )}
    </Typography>
  );

  if (!isMobile) {
    return <Box sx={mergeSx({ pb: 2.5 })}>{title}</Box>;
  }

  return (
    <Container sx={mergeSx({ display: 'flex', flexDirection: 'row', position: 'relative', alignItems: 'center', pb: 2 })}>
      {onGoBack ? (
        <Stack direction="row" sx={{ alignItems: 'center' }}>
          <Button onClick={onGoBack} sx={{ mr: 1.5 }} variant="text">
            <ChevronRightIcon fontSize="1.75rem" sx={{ transform: 'rotate(180deg)' }} />
          </Button>
          {title}
        </Stack>
      ) : (
        <Box sx={{ mx: 'auto' }}>{title}</Box>
      )}

      {endAdornment}
    </Container>
  );
};
